import { formatPrice } from "@/lib/utils";
import type {
  MarketplaceDynamicFilter,
  MarketplacePriceFilterValue,
  MarketplaceSelectedFilters,
} from "@/types/api/marketplace";

function formatFilterPriceAmount(value: string): string {
  return formatPrice(value, "INR", { compact: false });
}

export type AppliedFilterChipData = {
  id: string;
  filterType: string;
  label: string;
  /** Checkbox option id */
  optionId?: number;
  /** Price range field */
  priceField?: "min" | "max";
};

export function getCheckboxSelection(
  selectedFilters: MarketplaceSelectedFilters,
  type: string
): number[] {
  const val = selectedFilters[type];
  return Array.isArray(val) ? val : [];
}

export function buildAppliedModalFilterChips(
  modalFilters: MarketplaceDynamicFilter[],
  selectedFilters: MarketplaceSelectedFilters
): AppliedFilterChipData[] {
  const chips: AppliedFilterChipData[] = [];

  modalFilters.forEach((filter) => {
    if (filter.input_type === "checkbox" && filter.options) {
      const selected = getCheckboxSelection(selectedFilters, filter.type);
      filter.options.forEach((option) => {
        if (selected.includes(option.id)) {
          chips.push({
            id: `${filter.type}-${option.id}`,
            filterType: filter.type,
            optionId: option.id,
            label: option.label,
          });
        }
      });
    }

    if (filter.input_type === "price_range") {
      const price = selectedFilters[filter.type] as
        | MarketplacePriceFilterValue
        | undefined;
      if (price?.min) {
        chips.push({
          id: `${filter.type}-min`,
          filterType: filter.type,
          priceField: "min",
          label: `From ${formatFilterPriceAmount(price.min)}`,
        });
      }
      if (price?.max) {
        chips.push({
          id: `${filter.type}-max`,
          filterType: filter.type,
          priceField: "max",
          label: `Up to ${formatFilterPriceAmount(price.max)}`,
        });
      }
    }
  });

  return chips;
}
